// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 取消导入任务 POST /backend/import_task/cancel_import_task */
export async function postBackendImportTaskCancelImportTask(
  body: API.CancelImportTaskParams,
  options?: { [key: string]: any },
) {
  return request<API.CancelImportTaskResult>('/backend/import_task/cancel_import_task', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 创建任务并入队 POST /backend/import_task/create_import_task */
export async function postBackendImportTaskCreateImportTask(
  body: API.CreateImportTaskParams,
  options?: { [key: string]: any },
) {
  return request<API.CreateImportTaskResult>('/backend/import_task/create_import_task', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取OBS直传链接 POST /backend/import_task/get_import_signed_upload_url */
export async function postBackendImportTaskGetImportSignedUploadUrl(
  body: API.GetImportSignedUploadUrlParams,
  options?: { [key: string]: any },
) {
  return request<API.GetImportSignedUploadUrlResult>(
    '/backend/import_task/get_import_signed_upload_url',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 导入任务任务详情 POST /backend/import_task/get_import_task_detail */
export async function postBackendImportTaskGetImportTaskDetail(
  body: API.GetImportTaskDetailParams,
  options?: { [key: string]: any },
) {
  return request<API.GetImportTaskDetailResult>('/backend/import_task/get_import_task_detail', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 我的任务列表 POST /backend/import_task/get_import_task_list */
export async function postBackendImportTaskGetImportTaskList(
  body: API.GetImportTaskListParams,
  options?: { [key: string]: any },
) {
  return request<API.GetImportTaskListResult>('/backend/import_task/get_import_task_list', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 导入任务行明细分页 POST /backend/import_task/get_import_task_rows */
export async function postBackendImportTaskGetImportTaskRows(
  body: API.GetImportTaskRowsParams,
  options?: { [key: string]: any },
) {
  return request<API.GetImportTaskRowsResult>('/backend/import_task/get_import_task_rows', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取导入表头模板 根据返回的表头生成导入模板 POST /backend/import_task/get_import_tpl_headers */
export async function postBackendImportTaskGetImportTplHeaders(
  body: API.GetImportTplHeadersParams,
  options?: { [key: string]: any },
) {
  return request<API.GetImportTplHeadersResult>('/backend/import_task/get_import_tpl_headers', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
